import { render, staticRenderFns } from "./brain.vue?vue&type=template&id=29770eb6&scoped=true&"
import script from "./brain.vue?vue&type=script&lang=js&"
export * from "./brain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29770eb6",
  null
  
)

export default component.exports